var TorsoDataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var locationCollection = require('./locationCollection');

/**
 * Receives locations from the LocationExtService which serves the LocationDTO resource
 * @class LocationDataBehavior
 * @constructor
 */
module.exports = TorsoDataBehavior.extend({
  cache: locationCollection
});
